import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { computed } from 'vue'

interface Tokens {
  accessToken: string
  refreshToken: string
}

export const useMobileAuthStore = defineStore('mobileAuth', () => {
  const accessToken = useStorage<string | null>('moaAccessToken', null)
  const refreshToken = useStorage<string | null>('moaRefreshToken', null)
  const verifier = useStorage<string | null>('moaVerifier', null)

  const onMobileAuthTokensChange = async (tokens: Tokens) => {
    accessToken.value = tokens.accessToken
    refreshToken.value = tokens.refreshToken
  }

  const onMobileAuthNewVerifier = (value: string) => {
    verifier.value = value
  }

  const isLoggedInIntoMobileAuth = computed(() => accessToken.value !== null)

  const clearMobileAuthTokens = () => {
    accessToken.value = null
    refreshToken.value = null
  }

  const clearMobileAuthVerifier = () => {
    verifier.value = null
  }

  const $reset = () => {
    clearMobileAuthTokens()
    clearMobileAuthVerifier()
  }

  return {
    // State.
    isLoggedInIntoMobileAuth,
    accessToken: computed(() => accessToken),
    refreshToken: computed(() => refreshToken),
    verifier: computed(() => verifier),

    // Actions.
    onMobileAuthLogin: onMobileAuthTokensChange,
    onMobileAuthPhoneVerify: onMobileAuthTokensChange,
    onMobileAuthTokenRefresh: onMobileAuthTokensChange,
    onMobileAuthNewVerifier: onMobileAuthNewVerifier,

    clearMobileAuthTokens: clearMobileAuthTokens,
    clearMobileAuthVerifier: clearMobileAuthVerifier,
    onLogout: $reset,

    $reset
  }
})
